// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const DatePickerContract = contract({
  name: "DatePicker",
  description: "Any date or date-range entry. Use DatePicker for a single date (DOB, due date, booking). Use DateRangePicker for a span (report period, stay dates, filter window). Prefer these over <Input type=\"date\"> — consistent theming, keyboard nav, a11y, and no browser-native UI drift.",
  import: "@gradeui/ui",
  aliases: ["datepicker","calendar input","date field","date range","datepickerios","react native date picker","calendar input field","date field control"],
  subcomponents: ["DateRangePicker"],
  composesWith: ["Label","Form","Card (in CardContent)","Button (form submit)"],
  styleDefaults: {"DatePicker":"h-9 w-[280px] justify-start text-left text-base font-normal md:text-sm data-[empty=true]:text-muted-foreground","DateRangePicker":"h-9 w-[300px] justify-start text-left text-base font-normal md:text-sm data-[empty=true]:text-muted-foreground"},
  props: {
  "value": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "called on select or clear",
  },
  "placeholder": {
      schema: z.string().optional(),
      design: "content",
      description: "trigger label when empty (default \"Pick a date\" / \"Pick a date range\")",
  },
  "disabled": {
      schema: z.boolean().optional(),
      design: "knob",
  },
  "format": {
      schema: z.string().optional(),
      design: "content",
      description: "date-fns format token for the trigger label (default \"PPP\" single, \"LLL dd, y\" range)",
  },
  "align": {
      schema: z.enum(["start", "center", "end"]).optional(),
      design: "knob",
      description: "popover align (default \"start\")",
  },
  "side": {
      schema: z.enum(["top", "right", "bottom", "left"]).optional(),
      design: "knob",
      description: "popover side",
  },
  "captionLayout": {
      schema: z.enum(["label", "dropdown", "dropdown-months", "dropdown-years"]).optional(),
      design: "knob",
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
      description: "on the trigger button",
  },
  "contentClassName": {
      schema: z.string().optional(),
      design: "content",
      description: "on the PopoverContent",
  },
  "icon": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "replaces the default CalendarIcon",
  },
  "numberOfMonths": {
      schema: z.number().optional(),
      design: "knob",
      description: "DateRangePicker only, default 2",
  },
  },
});
